import React from "react";
import { ATTENDANCE_STATES, attendanceDetailText, attendanceState } from "../Events/utils/attendance";

// Full class strings per tone so Tailwind's content scan keeps them.
const TONE_CLASSES = {
  green: "bg-green-600 text-white",
  red: "bg-red-600 text-white",
  amber: "bg-amber-500 text-white",
  gray: "bg-gray-300 text-gray-700 dark:bg-gray-600 dark:text-gray-100",
};

// What a guest answered to "Can you make it?" (the day-before reminder).
// Renders nothing for a guest who was never asked. `entry` is their
// eventAttendance doc; what they wrote, or how they answered, rides along in
// the title.
const AttendanceBadge = ({ entry, className = "" }) => {
  const state = attendanceState(entry);
  if (!state) return null;
  const { label, tone } = ATTENDANCE_STATES[state];
  const title = entry.reply ? `Replied: "${entry.reply}"` : attendanceDetailText(entry);
  return (
    <span
      title={title}
      aria-label={`${label}. ${title}`}
      className={`inline-block rounded px-1 py-0.5 text-[10px] font-semibold leading-tight ${TONE_CLASSES[tone]} ${className}`}
    >
      {label}
    </span>
  );
};

export default AttendanceBadge;
